import TermsAndConditions from '@pages/terms/TermsAndConditions'
import styles from '@styles/TermsModal.module.css'
import PropType from 'prop-types'

const TermsModal = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>Términos y Condiciones</h2>
        <div className={styles.termsContent}>
          <TermsAndConditions />
        </div>
        <div className={styles.buttonContainer}>
          <button onClick={onAccept} className={styles.acceptButton}>
            Aceptar
          </button>
          <button onClick={onClose} className={styles.rejectButton}>
            No acepto
          </button>
        </div>
      </div>
    </div>
  )
}

TermsModal.propTypes = {
  isOpen: PropType.bool.isRequired,
  onClose: PropType.func.isRequired,
  onAccept: PropType.func.isRequired,
}

export default TermsModal
